import { Search, Calendar, Car, Route } from 'lucide-react';

export const HowItWorks = () => {
  const steps = [
    {
      icon: Search,
      title: 'Choose Your Car',
      description: 'Browse our fleet and pick the perfect vehicle for your journey'
    },
    {
      icon: Calendar,
      title: 'Select Dates',
      description: 'Pick your rental dates and choose self-drive or with-driver option'
    },
    {
      icon: Car,
      title: 'Book Instantly',
      description: 'Confirm your booking online or via WhatsApp in minutes'
    },
    {
      icon: Route,
      title: 'Hit the Road',
      description: 'Pick up your car and start your adventure across Pakistan'
    }
  ];

  return (
    <section className="py-24 px-6 bg-background" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm uppercase tracking-[0.2em] mb-3 font-mono text-accent">How It Works</p>
          <h2 className="text-4xl sm:text-5xl font-bold mb-4" style={{ fontFamily: 'Cabinet Grotesk' }}>
            Rent a Car in 4 Simple Steps
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            From selection to the open road — hassle-free car rental in minutes
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="relative text-center" data-testid={`step-${index}`}>
                {/* Step number */}
                <div className="w-16 h-16 bg-primary text-white rounded-full flex items-center justify-center mx-auto mb-4 relative z-10">
                  <Icon className="w-8 h-8" />
                </div>
                <div className="absolute top-6 left-1/2 -translate-x-1/2 w-8 h-8 bg-accent text-white rounded-full flex items-center justify-center font-bold text-sm z-20 -mt-8">
                  {index + 1}
                </div>

                {/* Connecting line (except last) */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-8 left-1/2 w-full h-0.5 bg-border -z-0" style={{ transform: 'translateX(50%)' }} />
                )}

                <h3 className="text-xl font-bold mb-2">{step.title}</h3>
                <p className="text-muted-foreground text-sm">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
